/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemFieldValueListSchema = z.object({
  data: z
    .object({})
    .catchall(z.any())
    .describe(
      'Custom field values keyed by field id. Each value object is tagged with the field type name (e.g. `LINK`) alongside `fieldType`; multi-value fields are arrays.',
    ),
});
